import { encodeString, decodeString } from 'use-query-params'

const LAST_CHARACTERS_TO_KEEP_COUNT = -16
const MINIMUM_CHARACTERS = 17

type StringParamType = string | (string | null)[] | null | undefined

export const SEOCountryQueryParam = {
  encode: (input: SEOCountries): StringParamType => encodeString(input),

  decode: (input: StringParamType): SEOCountries | null | undefined =>
    decodeString(input) as SEOCountries | null | undefined,
}

export const truncateUrl = (inputUrl: string) => {
  const url = inputUrl.slice().replace('https://', '').replace('http://', '')
  const firstSlashIndex = url.indexOf('/')
  const isShortUrl = url.length >= firstSlashIndex + MINIMUM_CHARACTERS
  const truncatedUrl = isShortUrl
    ? `${url.slice(0, firstSlashIndex + 1)}...${url.slice(
        LAST_CHARACTERS_TO_KEEP_COUNT
      )}`
    : url
  return truncatedUrl
}
